<script setup>
import {createApp, ref} from 'vue'
import {
  __,
  _mareike_nonce,
  _mareike_download_as_zip,
  notify,
  _mareike_use_webdav
} from "../../../assets/javascripts/library";
import LoadingModal from "../../../assets/components/LoadingModal.vue";
import Invoices from '../invoices/index.vue'
import {useAjax} from "../../../assets/javascripts/useAjax";
import CostUnitDetails from "./CostUnitDetails.vue";

const props = defineProps({
  data: {
    type: [Array, Object],
    default: () => []
  },

  deep_jump_id: {
    type: Number,
    default: 0
   },

  deep_jump_id_sub: {
    type: Number,
    default: 0
  }
})

const showInvoiceList = ref(false)
const invoices  = ref(null)
const current_cost_unit = ref(null)
const showLoading = ref(false)
const show_invoice = ref(false)
const invoice = ref(null)

const show_cost_unit = ref(false)
const costUnit = ref(null)


const { data, loading, error, request, download } = useAjax()

if (props.deep_jump_id > 0) {
  open_invoice_list(props.deep_jump_id, 'new', props.deep_jump_id_sub)
}

async function openCostUnit(id) {
  const url = `/wp-json/mareike/costunits/show?invoice_id=${invoice_id}&cost-unit-id=${id}&mareike_nonce=`+_mareike_nonce()

  try {
    const response = await fetch(url, { method: 'GET' })
    if (!response.ok) throw new Error('Fehler beim Laden')

    const result = await response.json()
    console.log(result.cost_unit)
    costUnit.value = result.cost_unit
    show_cost_unit.value = true
  } catch (err) {
    console.error('Error fetching invoices:', err)
  }
}

  async function open_invoice_list(cost_unit_id, endpoint, invoice_id) {
    const url = `/wp-json/mareike/invoices/list-${endpoint}?invoice_id=${invoice_id}&cost_unit_id=${cost_unit_id}&mareike_nonce=`+_mareike_nonce()
    try {
      const response = await fetch(url, { method: 'GET' })
      if (!response.ok) throw new Error('Fehler beim Laden')
      invoices.value = await response.json()
      current_cost_unit.value = cost_unit_id
      invoice_id = invoice_id
      showInvoiceList.value = true
    } catch (err) {
    }
  }

  async function deny_new_requests(cost_unit_id) {
    showLoading.value = true;
    await request("/wp-json/mareike/costunits/close", {
      method: "POST",
      body: {
        mareike_nonce: _mareike_nonce(),
        costunit: cost_unit_id,
      }
    });

    showLoading.value = false;
    notify(__('The cost unit was closed', 'mareike'), 'success');
  }


  async function archive_cost_unit(cost_unit_id) {
    showLoading.value = true;
    await request("/wp-json/mareike/costunits/archive", {
      method: "POST",
      body: {
        mareike_nonce: _mareike_nonce(),
        costunit: cost_unit_id,
      }
    });

    showLoading.value = false;
    notify(__('The cost unit was archived', 'mareike'), 'success');
  }


  async function allow_new_requests(cost_unit_id) {
    showLoading.value = true;
    await request("/wp-json/mareike/costunits/reopen", {
      method: "POST",
      body: {
        mareike_nonce: _mareike_nonce(),
        costunit: cost_unit_id,
      }
    });

    showLoading.value = false;
    notify(__('The cost unit was opened', 'mareike'), 'success');
  }

async function export_payouts(cost_unit_id) {
  showLoading.value = true;

  try {
    if (_mareike_download_as_zip()) {
      const response = await fetch("/wp-json/mareike/costunits/export-payouts", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          mareike_nonce: _mareike_nonce(),
          costunit: cost_unit_id,
        }),
      });

      if (!response.ok) throw new Error('Fehler beim Export (ZIP)');
      const blob = await response.blob();
      const downloadUrl = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = downloadUrl;
      a.download = `payouts-${cost_unit_id}.zip`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(downloadUrl);
    } else {
      await request("/wp-json/mareike/costunits/export-payouts", {
        method: "POST",
        body: {
          mareike_nonce: _mareike_nonce(),
          costunit: cost_unit_id,
        }
      });
    }
    showLoading.value = false;
    notify(__('The invoices were exported', 'mareike'), 'success');
  } catch (err) {
    showLoading.value = false;
    notify(__('Export failed', 'mareike'), 'error');
  }
}

</script>

<template>
  <table
      v-if="props.data.cost_units.length > 0 && !showInvoiceList"
      class="wp-list-table widefat fixed striped posts costunit-list">
    <thead>
      <tr>
        <th colspan="4" style="text-align: left;">  {{ props.data.cost_unit_title }}
        </th>
      </tr>
    </thead>
    <tr v-for="cost_unit in props.data.cost_units">
      <td style="width: 30%; font-weight: normal; font-size: 10pt; line-height: 1.8em;">
        <strong style="cursor: pointer; text-decoration: underline; color: #47a0d8;" @click="open_invoice_list(cost_unit.id, 'new')">{{ cost_unit.cost_unit_name }}</strong><br />
        {{__('Total amount', 'mareike') }}: {{ cost_unit.total_expenses }}<br />
        {{__('Donations', 'mareike') }}: {{ cost_unit.donations }}<br />
      </td>
      <td style="width: 30%; font-weight: normal; font-size: 10pt; line-height: 1.8em;">
        {{__('Unprocessed', 'mareike') }}: {{ cost_unit.count_new }}<br />
        {{__('Unexported', 'mareike') }}: {{ cost_unit.count_approved }}<br />
        {{__('Without payment', 'mareike') }}: {{ cost_unit.count_nopayout }}<br />
        {{__('Denied', 'mareike') }}: {{ cost_unit.count_denied }}<br />

      </td>
      <td style="width: 200px">
        <input @click="export_payouts(cost_unit.id)" type="button" class="mareike-button button-small button-block" :value="__('Export payouts', 'mareike')" />
        <input @click="allow_new_requests(cost_unit.id)" type="button" class="mareike-button button-small button-block" :value="__('Allow new requests', 'mareike')" v-if="!cost_unit.allow_new && !cost_unit.archived" />
        <input @click="deny_new_requests(cost_unit.id)" type="button" class="mareike-button button-small button-block" :value="__('Deny new requests', 'mareike')" v-else-if="cost_unit.allow_new && !cost_unit.archived" />
        <input @click="archive_cost_unit(cost_unit.id)" type="button" class="mareike-button button-small button-block" :value="__('Archive Cost unit', 'mareike')" v-if="!cost_unit.allow_new && !cost_unit.archived" />
        <input @click="openCostUnit(cost_unit.id)" type="button" class="mareike-button button-small button-block" :value="__('Change cost unit details', 'mareike')" v-if="!cost_unit.archived" />
      </td>
      <td></td>
    </tr>
  </table>

  <div v-else-if="showInvoiceList">
    <invoices :data="invoices" :load_invoice_id="props.deep_jump_id_sub" :cost_unit_id="current_cost_unit" />
  </div>

  <div v-else>
    {{ __('No cost units found', 'mareike') }}
  </div>

  <CostUnitDetails :data="costUnit" :showCostUnit="show_cost_unit" v-if="show_cost_unit" @close="show_cost_unit = false" />

  <LoadingModal :show="showLoading" v-if="_mareike_use_webdav()" :message="__('Exporting invoices, this may take up to 5 minutes.', 'mareike')" />
  <LoadingModal :show="showLoading" v-else :message="__('Exporting invoices, please wait.', 'mareike')" />
</template>

<style scoped>
 .costunit-list {
   width: 96% !important;
 }
</style>